/**
 * The generic lifecycle rail: a record view's `steps` (computed by each
 * step's owner, ordered by the object's declared lifecycle) drawn by the one
 * rail renderer. No per-object mapping: the 403-line order mapper is what
 * this replaces in One.
 */
import type { LifecycleRail, RailLink } from "../lifecycle-rail";
import type { LifecycleStep, ObjectRef } from "./contract";

function linkOf(ref: ObjectRef | null): RailLink | null {
  return ref ? { kind: "object", object: ref.object, id: ref.id } : null;
}

export function railOf(steps: readonly LifecycleStep[]): LifecycleRail {
  return {
    steps: steps.map((step) => ({
      id: step.step,
      name: step.label,
      state: step.state,
      problem: step.problem,
      status: step.status_lines.slice(0, 2),
      alert: step.problem ? step.alert : null,
      link: linkOf(step.link),
      detail: step.detail.map((item) => ({
        id: item.id,
        label: item.label,
        name: item.name,
        state: item.state,
        problem: item.problem,
        status: item.status,
        link: linkOf(item.link),
      })),
      info: step.info,
    })),
  };
}
